<template>
  <div>
    <b-row class="module_access_wrapper">
      <b-col lg="4" md="7" sm="12">
        <img src="@/assets/img/Security-amico.svg" />
        <p class="fs-medium  lh1">
          {{ label.errors.moduleAccess }}
          <br />
          <span class="fs-normal fw1b">
            {{ label.errors.supportTwo }}
          </span>
        </p>
        <b-button to="/" variant="ps-second">
          <b-icon
                  icon="house-fill"
                  scale="0.8"
                  class="align-middle ms-1"
          />
          {{ label.buttons.home }}
        </b-button>
        <b-button href="https://parsinaco.com/contactus" target="_blank" variant="ps-success" class="mx-3">
          <b-icon
                  icon="telephone-fill"
                  scale="0.8"
                  class="align-middle ms-1"
          />
          {{ label.buttons.parsinaContact }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import label from "@/plugins/StaticLabels.js";

export default {
  name: 'ModuleAccess',
  data () {
    return {
      label
    }
  },
}
</script>
